function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkUsersSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 891.88 884.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m201.74,381.63c-62.67,0-113.47,33.71-113.47,75.3v22.45c0,9.18,7.5,17.16,18.16,19.4,63.54,13.4,127.08,13.4,190.62,0,10.66-2.25,18.16-10.22,18.16-19.4v-22.45c0-41.59-50.8-75.3-113.47-75.3Z",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.74,
    cy: 307.7,
    r: 90.44,
    transform: "translate(-158.49 232.77) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.74,
    cy: 307.7,
    r: 69.16,
    transform: "translate(-65.3 54.58) rotate(-13.28)",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.8,381.63c-62.67,0-113.47,33.71-113.47,75.3v22.45c0,9.18,7.5,17.16,18.16,19.4,63.54,13.4,127.08,13.4,190.62,0,10.66-2.25,18.16-10.22,18.16-19.4v-22.45c0-41.59-50.8-75.3-113.47-75.3Z",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.8,
    cy: 307.7,
    r: 90.44,
    transform: "translate(-45.12 506.47) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.8,
    cy: 307.7,
    r: 69.16,
    transform: "translate(-54.95 143.51) rotate(-13.28)",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.27,576.73c-39.41,0-79.36-4.21-118.74-12.51-22.07-4.65-37.48-22.18-37.48-42.62v-27.01c0-31.01,17.33-59.59,48.79-80.47,28.98-19.23,67.13-29.82,107.43-29.82s78.45,10.59,107.43,29.82c31.46,20.88,48.79,49.46,48.79,80.47v27.01c0,20.44-15.41,37.96-37.48,42.62-39.38,8.3-79.33,12.51-118.74,12.51Z",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.27,403.99c-75.4,0-136.53,40.56-136.53,90.6v27.01c0,11.05,9.02,20.64,21.85,23.35,76.45,16.12,152.91,16.12,229.36,0,12.83-2.7,21.85-12.3,21.85-23.35v-27.01c0-50.04-61.13-90.6-136.53-90.6Z",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.74,
    cy: 306.26,
    r: 89.55,
    transform: "translate(-157.47 232.35) rotate(-45)",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.8,
    cy: 306.26,
    r: 89.55,
    transform: "translate(-44.1 506.05) rotate(-45)",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.8,
    cy: 306.26,
    r: 60.52,
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.74,
    cy: 306.26,
    r: 60.52,
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.27,
    cy: 395.27,
    r: 375.32,
    style: {
      fill: "none",
      stroke: "#3d5ba9",
      strokeMiterlimit: 10,
      strokeWidth: "39.89px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.69,
    cy: 667.09,
    r: 217.19,
    transform: "translate(-274.09 672.46) rotate(-45)",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.69,
    cy: 667.09,
    r: 183.8,
    transform: "translate(-274.09 672.46) rotate(-45)",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.64,
    y1: 667.09,
    x2: 784.74,
    y2: 667.09,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "56.62px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 674.69,
    y1: 777.14,
    x2: 674.69,
    y2: 557.04,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "56.62px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.27,
    cy: 313.21,
    r: 106.99,
    transform: "translate(-105.7 371.23) rotate(-45)",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.27,
    cy: 315.04,
    r: 83.22,
    transform: "translate(-106.99 371.77) rotate(-45)",
    style: {
      fill: "#3d5ba9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUsersSvg);
export default __webpack_public_path__ + "static/media/bulkUsersSvg.eb83d860f5860a661548c87e68de23ed.svg";
export { ForwardRef as ReactComponent };